"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FlexItem", {
  enumerable: true,
  get: function get() {
    return _FlexItem.default;
  }
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _View = _interopRequireDefault(require("../View"));

var _FlexItem = _interopRequireDefault(require("./FlexItem"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'cGJLp',
  template: function template(theme) {
    return "\n\n.cGJLp_bGBk{box-sizing:border-box;font-family:".concat(theme.fontFamily || 'inherit', "}\n\n.cGJLp_bZNM{flex-direction:column}\n\n.cGJLp_eUXf{flex-direction:column-reverse}\n\n.cGJLp_qOas{flex-direction:row}\n\n.cGJLp_sGoV{flex-direction:row-reverse}\n\n.cGJLp_ePRQ{flex-wrap:wrap}\n\n.cGJLp_busO{justify-content:flex-start}\n\n.cGJLp_crdn{justify-content:flex-end}\n\n.cGJLp_eRIA{justify-content:center}\n\n.cGJLp_flTs{justify-content:space-around}\n\n.cGJLp_oDLF{justify-content:space-between}\n\n.cGJLp_fZWR{align-items:center}\n\n.cGJLp_cCxO{align-items:flex-start}\n\n.cGJLp_fncw{align-items:flex-end}\n\n.cGJLp_cQFX{align-items:stretch}\n\n.cGJLp_fFVr{outline:0.0625rem dashed ").concat(theme.debugOutlineColor || 'inherit', "}");
  },
  'root': 'cGJLp_bGBk',
  'column': 'cGJLp_bZNM',
  'column-reverse': 'cGJLp_eUXf',
  'row': 'cGJLp_qOas',
  'row-reverse': 'cGJLp_sGoV',
  'wrapItems': 'cGJLp_ePRQ',
  'justifyItems--start': 'cGJLp_busO',
  'justifyItems--end': 'cGJLp_crdn',
  'justifyItems--center': 'cGJLp_eRIA',
  'justifyItems--space-around': 'cGJLp_flTs',
  'justifyItems--space-between': 'cGJLp_oDLF',
  'alignItems--center': 'cGJLp_fZWR',
  'alignItems--start': 'cGJLp_cCxO',
  'alignItems--end': 'cGJLp_fncw',
  'alignItems--stretch': 'cGJLp_cQFX',
  'visualDebug': 'cGJLp_fFVr'
};
var Flex = (
/**
---
category: components
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Flex, _Component);

  function Flex() {
    (0, _classCallCheck2.default)(this, Flex);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Flex).apply(this, arguments));
  }

  (0, _createClass2.default)(Flex, [{
    key: "renderChildren",
    value: function renderChildren() {
      var _this = this;

      return _react.Children.map(this.props.children, function (child) {
        if (child) {
          return (0, _safeCloneElement.default)(child, (0, _objectSpread2.default)({
            visualDebug: _this.props.visualDebug
          }, child.props, {
            /* child visualDebug prop should override parent */
            direction: _this.props.direction.replace(/-reverse/, '')
          }));
        } else {
          return null;
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var props = (0, _passthroughProps.omitProps)(this.props, Flex.propTypes);
      var _this$props = this.props,
          as = _this$props.as,
          children = _this$props.children,
          direction = _this$props.direction,
          height = _this$props.height,
          inline = _this$props.inline,
          margin = _this$props.margin,
          padding = _this$props.padding,
          justifyItems = _this$props.justifyItems,
          textAlign = _this$props.textAlign,
          visualDebug = _this$props.visualDebug,
          width = _this$props.width,
          wrapItems = _this$props.wrapItems; // When flex direction is row, 'center' is the most useful default because it
      // vertically aligns FlexItems. For column direction, though, we want 'stretch'.

      var alignItems = this.props.alignItems || (direction === 'column' || direction === 'column-reverse' ? 'stretch' : 'center');
      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles.visualDebug, visualDebug), (0, _defineProperty2.default)(_classes, styles["justifyItems--".concat(justifyItems)], true), (0, _defineProperty2.default)(_classes, styles["alignItems--".concat(alignItems)], true), (0, _defineProperty2.default)(_classes, styles.wrapItems, wrapItems), _classes);

      if (children && _react.default.Children.count(children) > 0) {
        return _react.default.createElement(_View.default, Object.assign({}, props, {
          className: (0, _classnames.default)(classes, styles[direction]),
          as: as,
          display: inline ? 'inline-flex' : 'flex',
          width: width,
          height: height,
          margin: margin,
          padding: padding,
          textAlign: textAlign
        }), this.renderChildren());
      } else {
        return null;
      }
    }
  }]);
  Flex.displayName = "Flex";
  return Flex;
}(_react.Component), _class2.propTypes = {
  /**
  * Flex only accepts FlexItem as a child
  */
  children: _uiPropTypes.Children.oneOf([_FlexItem.default]),

  /**
  * the element type to render as
  */
  as: _propTypes.default.elementType,

  /**
  * Sets the flex-direction to row (horizontal) or column (vertical)
  */
  direction: _propTypes.default.oneOf(['row', 'column', 'row-reverse', 'column-reverse']),

  /**
  * Sets the height of the component's container (optional)
  */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
  * Sets the width of the component's container (optional)
  */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  inline: _propTypes.default.bool,
  textAlign: _propTypes.default.oneOf(['start', 'center', 'end']),

  /**
  * Valid values are `0`, `none`, `auto`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `margin="small auto large"`.
  */
  margin: _ThemeablePropTypes.default.spacing,

  /**
  * Valid values are `0`, `none`, `xxx-small`, `xx-small`, `x-small`,
  * `small`, `medium`, `large`, `x-large`, `xx-large`. Apply these values via
  * familiar CSS-like shorthand. For example: `padding="small x-large large"`.
  */
  padding: _ThemeablePropTypes.default.spacing,
  alignItems: _propTypes.default.oneOf(['center', 'start', 'end', 'stretch']),
  justifyItems: _propTypes.default.oneOf(['center', 'start', 'end', 'space-around', 'space-between']),

  /**
  * Places dashed lines around the component's borders to help debug your layout
  */
  visualDebug: _propTypes.default.bool,
  wrapItems: _propTypes.default.bool
}, _class2.defaultProps = {
  children: null,
  as: 'span',
  direction: 'row',
  justifyItems: 'start',
  inline: false,
  visualDebug: false,
  wrapItems: false,
  width: void 0,
  height: void 0,
  padding: void 0,
  margin: void 0,
  alignItems: void 0,
  textAlign: void 0
}, _temp)) || _class);
exports.default = Flex;